import { memo } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import { Project } from "../types";
import styles from "./styles.module.scss";
import { stringAvatar } from "../../../utils/avatar";

type ProjectItemProps = {
  project: Project;
};

const ProjectItem = memo(({ project }: ProjectItemProps) => {
  return (
    <Card className={styles.divCard}>
      <CardContent>
        <div className={styles.projectKey}>{project.projectKey}</div>
        <div className={styles.projectName}>{project.title}</div>
        <div className={styles.projectManager}>
          <Avatar
            className={styles.avatar}
            {...stringAvatar(project.managerName)}
          />
          <label>{project.managerName}</label>
        </div>
      </CardContent>
    </Card>
  );
});

export default ProjectItem;
